<div [id]="modalId" class="modal" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content bg-white">
            <div class="modal-header">
                <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <h2 class="welcome">Herzlich willkommen!</h2>
                    </div>
                    <div class="col-12 col-md-6">
                        <h2 class="functions">Alle Funktionen im Überblick</h2>
                    </div>
                </div>

                <button class="d-md-none explore-button mb-3" data-bs-dismiss="modal" value="zum Buch">
                    zum Buch
                </button>

                <div class="d-flex justify-content-center align-items-stretch flex-wrap flex-md-nowrap gap-3 mb-4">
                    <div class="d-flex flex-column w-100">
                        <h3 class="text-center">Navigation im Buch</h3>
                        <div class="content">
                            <div class="d-flex justify-content-between align-items-center p-3">
                                <div class="p-2">
                                    <img [src]="'welcome/d4s-welcome-icon-blaettern-seiten.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Buchseiten blättern<br/> und Seitenwähler
                                    </div>

                                </div>
                                <div class="p-2">
                                    <img [src]="'sidebar/sidebar-icon-kapitel.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Kapitel &<br/> Lesezeichen
                                    </div>
                                </div>
                                <div class="p-2">
                                    <img [src]="'sidebar/sidebar-icon-suche.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Suche
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column w-100">
                        <h3 class="text-center">Werkzeuge (rechts)</h3>
                        <div class="content">
                            <div class="d-flex justify-content-between align-items-center p-3">
                                <div class="p-2">
                                    <img [src]="'welcome/d4s-welcome-icon-tool-notizen.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Notizen und Markierungen hinzufügen
                                    </div>

                                </div>
                                <div class="p-2">
                                    <img [src]="'welcome/d4s-welcome-icon-tool-zeichnen.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Zeichnen, Stempeln, Texte ins Buch schreiben
                                    </div>
                                </div>
                                <div class="p-2">
                                    <img [src]="'welcome/d4s-welcome-icon-tool-seitenexport.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Buchseiten mit Notizen herunterladen
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                @if (quickLinkService.quickLinks.genericQuickLinks.size +
                quickLinkService.quickLinks.hsmQuickLinks.size +
                quickLinkService.quickLinks.gmtQuickLinks.size +
                quickLinkService.quickLinks.eSquirrelQuickLinks.size > 0) {
                    <h3><span class="direct-access">E-BOOK PLUS</span>Vollzugang zu Übungen</h3>
                    <div class="d-flex mb-4">
                        <div class="content w-100">
                            <div class="d-flex flex-wrap flex-md-nowrap gap-3 justify-content-evenly p-3">
                                @if ((quickLinkService.quickLinks.hsmQuickLinks.size + quickLinkService.quickLinks.genericQuickLinks.size) > 0) {
                                    <div>
                                        <div class="img-wrapper">
                                            <img [src]="'welcome/d4s-welcome-icon-quicklink-empty.png' | asset"
                                                 [style.height.px]="50"
                                                 alt="Feature-Icon">
                                            <div [innerHTML]="generalText" [ngStyle]="{'top': '29px'}"
                                                 class="ql-text general"></div>
                                        </div>
                                        <div>
                                            Interaktive<br/> Beispiel-Links
                                        </div>
                                    </div>
                                }
                                @if ((quickLinkService.quickLinks.hsmQuickLinks.size) > 0) {
                                    <div>
                                        <div class="img-wrapper">
                                            <img [src]="'welcome/d4s-welcome-icon-hsm-empty.png' | asset"
                                                 [style.height.px]="50"
                                                 alt="Feature-Icon">
                                            <div [innerHTML]="hsmText" [ngStyle]="{'top': '25px'}"
                                                 class="ql-text hsm"></div>
                                        </div>
                                        <div>
                                            Aufgaben erstellen<br/>
                                            und wiederfinden
                                        </div>
                                    </div>
                                }
                                @if (quickLinkService.quickLinks.gmtQuickLinks.size > 0 &&
                                (applicationStateService.bookConfig.fullGmtFeature ||
                                    applicationStateService.bookConfig.fullGmtFeatureBac)) {
                                    <div>
                                        <div class="img-wrapper">
                                            <img [src]="'welcome/digi-fit-icon.png' | asset"
                                                 [style.height.px]="50"
                                                 alt="Feature-Icon">
                                            <div>
                                                digi.fit
                                            </div>
                                        </div>
                                    </div>
                                }
                                @if (quickLinkService.quickLinks.eSquirrelQuickLinks.size > 0 &&
                                (applicationStateService.bookConfig.fullESquirrelFeature ||
                                    applicationStateService.bookConfig.fullESquirrelFeatureBac)) {
                                    <div>
                                        <div class="img-wrapper">
                                            <img [src]="'welcome/d4s-welcome-icon-esquirrel-empty.png' | asset"
                                                 [style.height.px]="50"
                                                 alt="Feature-Icon">
                                            <div [innerHTML]="eSquirrelText" [ngStyle]="{'top': '25px'}"
                                                 class="ql-text esquirrel"></div>
                                            <div>
                                                eSquirrel
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }

                <div class="d-flex justify-content-center align-items-stretch flex-wrap flex-md-nowrap gap-3">
                    <div class="d-flex flex-column w-100">
                        <h3 class="text-center">Infos und zuletzt verwendete Bücher</h3>
                        <div class="content">
                            <div class="d-flex justify-content-between align-items-center p-3">
                                <div class="p-2">
                                    <img [src]="'topbar-icon-digibuch-white-blue.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Buchliste und <br/>zuletzt verwendet
                                    </div>

                                </div>
                                <div class="p-2">
                                    <img [src]="coverURL"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <i aria-hidden="true" class="fa fa-caret-down"></i>
                                    <div>
                                        Buchinfos,<br/> Offline-Version
                                    </div>
                                </div>
                                <div class="p-2">
                                    <img [src]="'topbar-icon-materialien.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Zugehörige Materialien
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column w-100">
                        <h3 class="text-center">Ansicht und Darstellung</h3>
                        <div class="content">
                            <div class="d-flex justify-content-between align-items-center p-3">
                                <div class="p-2">
                                    <img [src]="'welcome/d4s-welcome-icon-auge.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Buchinhalte<br/> ein- und ausblenden
                                    </div>

                                </div>
                                <div class="p-2">
                                    <img [src]="'welcome/d4s-welcome-icon-ansicht.png' | asset"
                                         [style.height.px]="40"
                                         alt="Feature-Icon">
                                    <div>
                                        Blättern oder Scrollansicht<br/> und Vollbildmodus
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <div class="d-flex gap-2 flex-wrap flex-md-nowrap align-items-center w-100 justify-content-evenly">
                    <div class="text-start">
                        Hast du weitere Fragen? <a href="{{ routeService.getAbsoluteRoute('faq', []) }}"
                                                   target="_blank">FAQ</a> | <a
                            href="{{ routeService.getAbsoluteRoute('contact', []) }}" target="_blank">Support</a>
                    </div>
                    <div class="text-center">
                        <button class="explore-button" data-bs-dismiss="modal" value="zum Buch">zum Buch
                        </button>
                    </div>
                    <div class="text-end">
                        <button (click)="change.emit()" class="show-text">
                            <i [class.fa-check-square]="showContent" [class.fa-square]="!showContent" class="fa"></i>
                            Info beim nächsten Besuch anzeigen
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
